module.exports = __webpack_public_path__ + "img/icono_bisturi.1c218d1a.svg";